const translations = {
    apiError: 'Something went wrong. Please try again.',
    title: 'Edit Aircraft'
};

export default translations;
